import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=2be5c251&scoped=true"
import script from "./createTask.vue?vue&type=script&lang=js"
export * from "./createTask.vue?vue&type=script&lang=js"
import style0 from "./createTask.vue?vue&type=style&index=0&id=2be5c251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5c251",
  null
  
)

export default component.exports